import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedDate: '',
    isChecked: true,
    pageerror: '',
    basicDetails: null,
    redirectionLink: null,
    locDetails: null,
    ifscBankDetails: null,
    partnerLocDetails: null,
    allDetailsAvailable: false,
    loanSummaryData: null,
    customerFeatureFlag: null,
};

const eligibilitySlice = createSlice({
    name: 'eligibility',
    initialState,
    reducers: {
        setSelectedDate(state, action) {
            state.selectedDate = action.payload;
        },
        setIsChecked(state, action) {
            state.isChecked = action.payload;
        },
        setPageError(state, action) {
            state.pageerror = action.payload;
        },
        setBasicDetails(state, action) {
            state.basicDetails = action.payload;
        },
        setLocDetails(state, action) {
            state.locDetails = action.payload;
        },
        setDetailsAvailable(state, action) {
            state.allDetailsAvailable = action.payload;
        },
        setRedirection(state, action) {
            state.redirectionLink = action.payload;
        },
        setPartnerLocDetails(state, action) {
            state.partnerLocDetails = action.payload;
        },
        setLoanSummary(state, action) {
            state.loanSummaryData = action.payload;
        },
        setIfscBankDetails(state, action) {
            state.ifscBankDetails = action.payload;
        },
        setCustomerFeatureFlag(state, action) {
            state.customerFeatureFlag = action.payload;
        }
    },
});

export const { setSelectedDate, setIsChecked, setPageError, setBasicDetails, setLocDetails, setDetailsAvailable, setRedirection, setPartnerLocDetails, setLoanSummary, setIfscBankDetails, setCustomerFeatureFlag } = eligibilitySlice.actions;

export default eligibilitySlice.reducer;
